import { getRequestEvent } from 'solid-js/web';
const color = {
  reset: '\x1b[0m',
  cyanBright: '\x1b[96m',
  yellowBright: '\x1b[93m',
  greenBright: '\x1b[92m',
  magentaBright: '\x1b[95m',
  gray: '\x1b[90m',
};

export const ssrLog = (...args: any[]) => {
  if (!import.meta.env.SSR) return;
  const event = getRequestEvent();

  if (!event) return;
  if (!event.locals.requestStartTime) {
    event.locals.requestStartTime = performance.now();
  }

  const duration = performance.now() - event.locals.requestStartTime;

  const msColor = duration < 100 ? color.greenBright : duration < 300 ? color.yellowBright : color.magentaBright;

  console.log(
    `${color.cyanBright}⏱ [TIMING]${color.reset} ${msColor}${duration.toFixed(1)}ms${color.reset} ${color.gray}`,
    ...args,
    color.reset
  );
};
